import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CompanySubscriptionsFilterEntity } from '../../domain/entities/CompanySubscriptionsFilterEntity'

export class CompanySubscriptionsFilterModel {
  id!: number
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean

  constructor(dataDto: CompanySubscriptionsFilterEntity) {
    mapEntityProperties<CompanySubscriptionsFilterModel>(this, dataDto, {
      map: {
        id: dataDto.company?.id
      }
    })
  }
}